import { axios, config } from 'data';
import { Profile } from 'types/models';
import { ProfileBalancesResponse, ProfilePasswordUpdateParams, ProfileUpdateParams } from 'types/services';

const getProfile = async () => {
  const response = await axios.get<Profile>('/client/personal-data');

  return response.data;
};

const populateProfile = async (params: ProfileUpdateParams) => {
  await axios.post<never>('/client/save-personal-data', params);
};

const updateProfile = async (params: ProfileUpdateParams) => {
  await axios.patch<never>('/client/update-personal-data', params);
};

const updatePassword = async (oldPassword: string, newPassword: string) => {
  const params: ProfilePasswordUpdateParams = { oldPassword, newPassword };

  await axios.post<never>('/auth/change-password', params);
};

const getBalances = async () => {
  const response = await axios.get<ProfileBalancesResponse>('/client/balance');

  return response.data.balances;
};

const getBalance = async () => {
  const balances = await getBalances();

  return balances.filter((balance) => balance.currency === config.DEFAULT_CURRENCY)[0];
};

const profileService = {
  getProfile,
  populateProfile,
  updateProfile,
  updatePassword,
  getBalance,
};

export default profileService;
